module.exports = __webpack_public_path__ + "static/media/mail-icon-open.b0ef5a39.png";